// NOTE: Accepts `length`, `percentage`, `keyword`, and `global` values.

let PopoverCssProperty = /*#__PURE__*/function (PopoverCssProperty) {
  PopoverCssProperty["ZIndex"] = "--osui_popover-zindex";
  PopoverCssProperty["Position"] = "--osui_popover-position";
  PopoverCssProperty["Top"] = "--osui_popover-top";
  PopoverCssProperty["Right"] = "--osui_popover-right";
  PopoverCssProperty["Bottom"] = "--osui_popover-bottom";
  PopoverCssProperty["Left"] = "--osui_popover-left";
  PopoverCssProperty["Width"] = "--osui_popover-width";
  PopoverCssProperty["MinWidth"] = "--osui_popover-min-width";
  PopoverCssProperty["MaxWidth"] = "--osui_popover-max-width";
  PopoverCssProperty["Height"] = "--osui_popover-height";
  PopoverCssProperty["MinHeight"] = "--osui_popover-min-height";
  PopoverCssProperty["MaxHeight"] = "--osui_popover-max-height";
  PopoverCssProperty["Transition"] = "--osui_popover-transition";
  return PopoverCssProperty;
}({});

export { PopoverCssProperty };
